// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .logoBranco {
  height: 2.8rem;
}

.titulo {
  text-align: center;
  font-family: "inter";
  font-weight: 400;
  font-size: calc(0.3rem + 1.6vmin);
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2) ;
  letter-spacing: 0.1rem;
} */

.styles_botaoSair__46T2I {
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  font-weight: 900 !important;
}

.styles_botaoSair__46T2I:hover {
  background-color: #ffffff !important;
  color: #0f2047 !important;
}

.styles_menuPrincipal__9ZQ51 {
  background-color: rgba(15, 32, 71, 0.1) !important;
}

.styles_cabecalhoMenuSecoes__F7FWL {
  background-color: #0f2047 !important;
  color: #ffffff !important;
}

.styles_iconeCabecalhoMenuSecoes__B5VOy {
  color: #ffffff !important;
}

.styles_textoCabecalho__BqOhS {
  font-family: "Inter" !important;
  color: #ffffff !important;
  font-size: 12px !important;
}

.styles_logoMenu__RcCJU {
  width: 120px !important;
  height: auto !important;
}

.styles_notification__Btn__ZiXgj {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
}

.styles_notification__Btn__ZiXgj:hover {
  transform: scale(1.1);
}

.styles_userLogoutWrapper__8LVZp {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.styles_userNameHeader__vhXyZ {
  color: #fff !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  max-width: 12rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 600px) {
  .styles_userNameHeader__vhXyZ {
    max-width: 6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/styles.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;GAWG;;AAEH;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* .logoBranco {\n  height: 2.8rem;\n}\n\n.titulo {\n  text-align: center;\n  font-family: \"inter\";\n  font-weight: 400;\n  font-size: calc(0.3rem + 1.6vmin);\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2) ;\n  letter-spacing: 0.1rem;\n} */\n\n.botaoSair {\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  font-weight: 900 !important;\n}\n\n.botaoSair:hover {\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n}\n\n.menuPrincipal {\n  background-color: rgba(15, 32, 71, 0.1) !important;\n}\n\n.cabecalhoMenuSecoes {\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n}\n\n.iconeCabecalhoMenuSecoes {\n  color: #ffffff !important;\n}\n\n.textoCabecalho {\n  font-family: \"Inter\" !important;\n  color: #ffffff !important;\n  font-size: 12px !important;\n}\n\n.logoMenu {\n  width: 120px !important;\n  height: auto !important;\n}\n\n.notification__Btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: all 0.3s ease-in-out;\n}\n\n.notification__Btn:hover {\n  transform: scale(1.1);\n}\n\n.userLogoutWrapper {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.userNameHeader {\n  color: #fff !important;\n  font-size: 0.875rem !important;\n  font-weight: 500 !important;\n  max-width: 12rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 600px) {\n  .userNameHeader {\n    max-width: 6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoSair": `styles_botaoSair__46T2I`,
	"menuPrincipal": `styles_menuPrincipal__9ZQ51`,
	"cabecalhoMenuSecoes": `styles_cabecalhoMenuSecoes__F7FWL`,
	"iconeCabecalhoMenuSecoes": `styles_iconeCabecalhoMenuSecoes__B5VOy`,
	"textoCabecalho": `styles_textoCabecalho__BqOhS`,
	"logoMenu": `styles_logoMenu__RcCJU`,
	"notification__Btn": `styles_notification__Btn__ZiXgj`,
	"userLogoutWrapper": `styles_userLogoutWrapper__8LVZp`,
	"userNameHeader": `styles_userNameHeader__vhXyZ`
};
export default ___CSS_LOADER_EXPORT___;
